// extracted by mini-css-extract-plugin
export default {"hidden":"Menu_hidden__ynNte","menu-background":"Menu_menu-background__xRroH","menu":"Menu_menu__FWWEx","container":"Menu_container__gHg5n","btn-quit":"Menu_btn-quit__GiCd6"};